import { useStaticQuery, graphql } from "gatsby"

export const useHomeNewMetadata = () => {
  const homeNewData = useStaticQuery(
    graphql`
      query HomeNewMetaData {
        wpPage(id: { eq: "cG9zdDoxMQ==" }) {
          id
          title
          slug
          homePageNewFields {
            homeBannerNewList {
              bannerBtnText
              bannerContent
              homeBannerSubTitle
              homeBannerTitle
              bannerButtonLink {
                url
              }
              bgImage {
                altText
                mediaItemUrl
              }
            }

            relatedBlogsShowSection
            relatedBlogsTitle
            relatedBlogsSubTitle
            relatedBlogsContent
            homeVideoShowSection
            homeVideoTitle
            homeVideoSubTitle
            homeVideoContent
            homeVideoLink {
              url
            }
            homeBannerShowCelebrationImage
            homeBannerCelebrationImage {
              mediaItemUrl
              altText
            }
            homeHimsSideImage {
              mediaItemUrl
              altText
            }
            homeHimsShowSection
            homeHimsTitle
            homeHimsSubTitle
            homeHimsDate
            homeHimsContent
            homeHimsButtonText
            homeHimsButtonLink

            homeFaqSchema
            faqTitle
            faqSubTitle
            faqSmallContent
            faqShowSection
            faqContent
            faqButtonText
            faqButtonLink {
              url
            }
            homeNewFaqQuestionAnswersList {
              faqListAnswer
              faqListQuestion
              fieldGroupName
            }
            fieldGroupName
            homeBannerButtonLink {
              target
              title
              url
            }
            homeBannerButtonText
            homeBannerContent
            homeBannerTitle
            homeBlogContent
            homeBlogTitle
            homeCaseContent
            homeCaseTitle
            homeDomainContent
            homeDomainTitle
            homeTechContent
            homeTechTitle
            homeTestimonialsContent
            homeTestimonialsTitle
            homeWhoWeContent
            homeWhoWeTitle
            homeBannerBackgroundImage {
              mediaItemUrl
              altText
            }
            siteBlackLogo {
              mediaItemUrl
              altText
            }
            siteWhiteLogo {
              mediaItemUrl
              altText
            }

            homeNewCounterList {
              fieldGroupName
              homeCounterListSubTitle
              homeCounterListTitle
            }
            homeBannerShowSection
            homeCounterShowSection
            homeWhoWeShowSection
            homeWhoWeSubTitle
            homeCaseShowSection
            homeServiceTitle
            homeServiceSubTitle
            homeServiceShowSection
            homeServiceContent
            homeDomainShowSection
            homeDomainSubTitle
            homeBannerVideoLink {
              mediaItemUrl
            }
            homeNewDomainImageTextList {
              homeDomainListTitle
              homeDomainListIcon
              homeDomainListImage {
                altText
                mediaItemUrl
              }
              homeDomainListLink {
                url
              }
            }
            homeNewServiceImageContentList {
              homeServiceListTitle
              homeServiceListImage {
                altText
                mediaItemUrl
              }
              servicesInfo {
                servicesInfoTitle
                serviceButtonLink {
                  url
                  title
                }
                serviceInfoContent
                serviceInfoButtonText
                serviceInfoList {
                  serviceInfoListText
                  serviceInfoListLink {
                    url
                  }
                }
              }
            }
            homeBlogShowSection
            homeBlogSubTitle
            homeCaseSubTitle
            homeTechShowSection
            homeTechSubTitle
            homeTestimonialsShowSection
            homeTestimonialsSubTitle
            homeNewWhoWeIconTextList {
              fieldGroupName
              homeWhoWeListContent
              homeWhoWeListLinkText
              homeWhoWeListTitle
              homeWhoWeListLinkUrl {
                url
                title
                target
              }
              homeWhoWeListIcon
            }
            selectBlogs {
              ... on WpPost {
                id
                databaseId
                categories {
                  nodes {
                    name
                  }
                }
                categories {
                  nodes {
                    name
                  }
                }
                singlePageFieldsNew {
                  viewsCountShowSection
                  viewsCount
                  authorDesignation
                  authorName
                  showAuthor
                  authorImage {
                    mediaItemUrl
                    altText
                  }
                }
                featuredImage {
                  node {
                    mediaItemUrl
                    altText
                  }
                }
                date
                content
                title
                slug
              }
            }

            tagline
            discoverMvpShowSection
            discoverMvpTitle
            discoverMvpTag
            discoverMvpCta {
              url
              title
              target
            }
            discoverMvpImage {
              altText
              id
              mediaItemUrl
            }
            wwdSubtitle
            wwdTag
            wwdTitle
            wwdImage {
              altText
              id
              mediaItemUrl
            }
            selectCaseStudies {
              ... on WpCaseStudy {
                id
                title
                slug
                featuredImage {
                  node {
                    mediaItemUrl
                    altText
                  }
                }
                content
                CaseStudiesPostFieldsNew {
                  caseIndustryTag
                  caseSolutionTag
                  caseSolution
                  caseIndustry
                  caseTitle
                  caseSubTitle
                  caseCountry
                  portfolioDarkColorCode
                  portfolioLightColorCode
                  portfolioTextColorCode
                  portfolioParentClassName
                }
              }
            }
            selectTestimonials {
              ... on WpTestimonial {
                id
                title
                slug
                content
                featuredImage {
                  node {
                    mediaItemUrl
                    altText
                  }
                }
                TestimonialPostFields {
                  testMatchRate
                }
                TestimonialsField {
                  country
                  feedback
                  position
                  videoLink {
                    altText
                    mediaItemUrl
                  }
                  pageLink
                }
              }
            }
            homeNewWhyIconTextList {
              fieldGroupName
              homeWhyListIconSubtitle
              homeWhyListIconText
              homeWhyListIcon
            }
            homeWhyShowSection
            homeWhySubTitle
            homeWhyContent
            homeWhyTitle
            homeWhyAgileContect
            homeWhyVideoUrl
            homeWorkContent
            homeWorkShowSection
            homeWorkSubTitle
            homeWorkTitle
            homeNewWorkLogoList {
              homeWorkListLogoImage {
                mediaItemUrl
                altText
              }
            }
            homeBlogViewAllLink {
              ... on WpPage {
                id
                link
              }
            }
            homeTestimonialsViewAllLink {
              ... on WpPage {
                id
                link
              }
            }
            schemaScript
            homeAllianceSection
            homeNewAllianceImageList {
              homeAllianceListLink
              homeAllianceListImage {
                mediaItemUrl
                altText
              }
            }
            homeAllianceTitle
            homeAllianceSubTitle
            homeAllianceContent

            engageContent,
            engageIconContentList {
              engageListContent
              engageListIcon
              engageListLinkText
              engageListText
              fieldGroupName
            }
            engageSection,
            engageSubtitle,
            engageTitle
          }
          MetaFields {
            customPageSchema
            customSeoFocusKeyphrase
            customSeoKeywords
            customSeoMetaDescription
            customSeoMetaTitle
            customSeoRobotFollow
            customSeoRobotIndex
            fieldGroupName
            customSeoOgUrl
          }
        }
        wp {
          myThemeOptionsSettings {
            agileSkypeName
            clutchRating
            clutchReviews
            contactIndiaNumber
            contactUsText
            contactUsaNumber
            copyrightText
            customLogo
            dallasContactAddress
            dallasText
            emailsText
            facebookLink
            favicon
            floridaContactAddress
            floridaText
            googleRating
            googleReviews
            hrEmail
            indiaContactAddress
            indiaText
            inquiryEmail
            instagramLink
            linkedinLink
            logo
            blklogo
            skypeName
            twitterLink
            usaOfficeText
            subscribeSectionText
            youtubeLink
            ogTagText
            contactNumber
          }
        }

        allWpTechnologyStackCategory {
          edges {
            node {
              id
              name
            }
          }
        }

        allWpTechnologyStack(sort: { date: DESC }) {
          edges {
            node {
              id
              title
              link
              technologyStackscategories {
                nodes {
                  id
                  name
                }
              }
              TechnologyStackPostFields {
                technologyStackIcon
              }
            }
          }
        }

        wpMenu(databaseId: { eq: 71 }) {
          id
          name
          menuItems {
            nodes {
              id
              label
              url
            }
          }
        }
      }
    `
  )

  return homeNewData
}
